// axios
import request from '@/utils/request'
import api from '@/api/config.js'
import { get, omit, cloneDeep } from 'lodash'
// 生成api 方法
function genApi() {
  const Api = new Map()
  Object.keys(api).forEach(key => {
    const { method, url, pathKey, containQuery, responseType, isHeaders } = api[key]
    let finalUrl = url
    Api[key] = params => {
      if (/:\w+/.test(url) && pathKey && params) {
        finalUrl = url.replace(/:\w+/, get(params, pathKey))
      }
      if (!params) params = {}
      if (containQuery || (Object.keys(params).length && method.toLowerCase() === 'get' && params && !params.params)) { // 参数中未使用axios自带query参数拼接时
        const otherParams = { params: omit(cloneDeep(params), pathKey) }// ?query参数 去除path :id, 然后构造一个{params: {}}参数传给axios
        return request[method](finalUrl, otherParams)
      }
      if (responseType) {
        return request[method](finalUrl, params, { responseType: responseType })
      }
      // if(isHeaders) {
      //   // 携带headers 拼接上去 需要从 参数里面拼接headers
      //   return request[method](finalUrl, params, { headers: {...params.headers} })
      // }

      return request[method](finalUrl, params) // axios自带query参数拼接
    }
  })
  return Api
}
export const Api = genApi()

